import React, {CSSProperties, Dispatch, SetStateAction, useCallback} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowCircleLeft , faCheckCircle} from "@fortawesome/free-solid-svg-icons";
import MemoCoinImage from "../../components/CoinImage";
import binace from "../../assets/binance.svg";
import eth from "../../assets/ethereum.svg";
import polygon from "../../assets/polygon.svg";
import klaytn from "../../assets/klaytn.svg";
import solana from "../../assets/solana.svg";
import {ChainId, ICurrentSelectNetwork} from "../../types/type";
import {useTranslation} from "react-i18next";


interface IChangeNetWork {
    setPrevPageAnimation: Dispatch<SetStateAction<boolean>>
    setStep: Dispatch<SetStateAction<number>>
    currentSelectNetwork: ICurrentSelectNetwork
    setCurrentSelectNetwork: Dispatch<SetStateAction<ICurrentSelectNetwork>>
}




const smallLogoCSS: CSSProperties = {width: '30px', height: '30px'}
export const CHAIN_NETWORK_LIST : ICurrentSelectNetwork[] = [
    {
        chainId: "0x1",
        name: 'Ethereum',
        logo: <MemoCoinImage bgColor={'eth-bg-color'} logoSrc={eth} coinName={'Ethereum'} style={smallLogoCSS}/>,
        networkUrl : "https://cloudflare-eth.com",
        symbol : 'ETH',
        blockExplorerUrls : 'https://cloudflare-eth.com',
        nativeCurrency: {
            name: 'ETH',
            symbol: 'ETH',
            decimals: 18
        }
    },
    {
        chainId: '0x38',
        name: 'Binance Smart Chain Mainnet',
        logo: <MemoCoinImage bgColor={'bsc-bg-color'} logoSrc={binace} coinName={'binance'} style={smallLogoCSS}/>,
        networkUrl : "https://bsc-dataseed1.binance.org",
        symbol : 'BNB',
        blockExplorerUrls : 'https://bscscan.com',
        nativeCurrency: {
            name: 'BNB',
            symbol: 'BNB',
            decimals: 18
        }
    },
    {
        chainId: '0x89',
        name: 'Polygon Mainnet',
        logo: <MemoCoinImage bgColor={'matic-bg-color'} logoSrc={polygon} coinName={'Polygon'} style={smallLogoCSS}/>,
        networkUrl : "https://polygon-rpc.com",
        symbol : "MATIC",
        blockExplorerUrls : 'https://polygonscan.com/',
        nativeCurrency: {
            name: 'MATIC',
            symbol: 'MATIC',
            decimals: 18
        }
    },
    {
        chainId: '0x2019',
        name: "Klaytn Mainnet Cypress",
        logo: <MemoCoinImage bgColor={'klay-bg-color'} logoSrc={klaytn} coinName={'klaytn'} style={smallLogoCSS}/>,
        networkUrl : "https://public-node-api.klaytnapi.com/v1/cypress",
        symbol : "KLAY",
        blockExplorerUrls : 'https://scope.klaytn.com/',
        nativeCurrency: {
            name: 'KLAY',
            symbol: 'KLAY',
            decimals: 18
        }
    },
    {
        chainId: 'sol',
        name: "Solana",
        logo: <MemoCoinImage bgColor={'sol-bg-color'} logoSrc={solana} coinName={'solana'} style={smallLogoCSS}/>,
        networkUrl : "https://bsc-dataseed.binance.org",
        symbol : "",
        blockExplorerUrls : 'https://scope.klaytn.com/',
        nativeCurrency: {
            name: 'KLAY',
            symbol: 'KLAY',
            decimals: 18
        }
    }
]


const ChangeNetwork: React.FC<IChangeNetWork> =
    ({
         setPrevPageAnimation,
         setStep,
         currentSelectNetwork,
         setCurrentSelectNetwork
     }) => {

        const goBackMyPage = useCallback(() => {
            setPrevPageAnimation(true);
            setStep(2)
        }, [])


        const switchNetwork = async (chain : ICurrentSelectNetwork) => {

            const response = CHAIN_NETWORK_LIST.find((item) => item.chainId === chain.chainId);

            if (chain.chainId === 'sol' && response) {
                return setCurrentSelectNetwork(response);
            }

            if (window.ethereum) {
                try {
                    // check if the chain to connect to is installed
                    await window.ethereum.request({
                        method: 'wallet_switchEthereumChain',
                        params: [{chainId : chain.chainId}], // chainId must be in hexadecimal numbers
                    });
                    if (response) {
                        setCurrentSelectNetwork(response)
                    }
                } catch (error: any) {
                    if (error.code === 4902) {
                        try {
                            await window.ethereum.request({
                                method: 'wallet_addEthereumChain',
                                params: [
                                    {
                                        chainId : chain.chainId,
                                        rpcUrls: [chain.networkUrl],
                                        chainName: chain.name,
                                    }
                                ],
                            })
                        } catch (addError) {
                            console.log(`Add Error` , addError)
                        }
                    }
                    console.error('wallet_switchEthereumChain ::: ', error);
                }
            } else {
                // if no window.ethereum then MetaMask is not installed
                alert('MetaMask is not installed. Please consider installing it: https://metamask.io/download.html');
            }
        }


        const {t} = useTranslation()

        return (
            <section className={'flex flex-col items-start'}>
                <article className={'flex items-center w-full'}>
                    <FontAwesomeIcon icon={faArrowCircleLeft} onClick={goBackMyPage} className={'cursor-pointer'}/>
                    <span className={'w-full inline-block text-center'}>{t('change-network')}</span>
                </article>
                <ul className={'flex flex-col mt-7 gap-3 w-full'}>
                    {
                        CHAIN_NETWORK_LIST.map((chain) => {
                            return (
                                <li className={'rounded-md flex  items-center justify-between p-1.5 px-2 border-solid border border-gray-300 hover:bg-slate-100 cursor-pointer'}
                                    onClick={() => switchNetwork(chain)}
                                    key={chain.chainId}>
                                <span className={'flex items-center'}>
                                    {chain.logo}
                                    <span className={'ml-3'}>{chain.name}</span>
                                </span>
                                    {
                                        currentSelectNetwork.chainId === chain.chainId &&
                                        <span className={'rounded-full border-solid border-gray-300 text-xs'}>
                                            <FontAwesomeIcon icon={faCheckCircle} className={'text-green-600'}/>
                                        </span>
                                    }

                                </li>
                            )
                        })
                    }
                </ul>
            </section>
        )
    }
export default ChangeNetwork